module.exports = __webpack_public_path__ + "static/media/subscribe_icon_del_self.459ca4a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/subscribe_icon_del_self.png
// module id = 2178
// module chunks = 0